require('./external');
require('./AccountApp.scss');
require('common/common.scss');

require('common/Routing');
require('common/SiteNav/SiteNav');
require('common/User/User');
require('common/Login/Login');
require('common/Forms/Forms');
require('common/app_metadata');
require('common/api');

require('directives/joinCode');

var m = require('am');

m.config(['$urlRouterProvider', '$stateProvider',
 function($urlRouterProvider, $stateProvider) {

  $urlRouterProvider.otherwise('/');

  var s = $stateProvider;

  s.state('root', {
    url: '/',
    data: {},
    resolve: {
      user: ['$api', function($api) {
        return $api.get('/n/account/api/');
      }],
    },
    template: "<div ui-view></div>",
    controller: ['$scope', '$state', 'user', 'check_login',
     function($scope, $state, user, check_login) {
      if (!$state.current.data.public) {
        check_login(user).then(() => {window.location = '/'});
      }
      $scope.user = user;
    }]
  });

  s.state('sso_decline', {
    url: '/oauth_client_declined?retry_url',
    data: {
      title: 'AcademicMerit',
      public: true,
    },
    template: `
      <h3>Authorization Declined</h3>
      <p>
        You have declined to allow your College Board account to be used to give you access
        to AP Insight on the AcademicMerit platform. You will not be able to use AP Insight
        on the AcademicMerit platform until you grant permission.
      </p>
      <div ng-if="$stateParams.retry_url">
        <p>
        Click <a href="{{$stateParams.retry_url}}">here</a> if you wish to try again and change your answer.
        </p>
        <p>
        Or you can click <a href="https://apinsight.collegeboard.org/">here</a> to return to the AP Insight homepage.
        </p>
      </div>
      <div ng-if="$stateParams.retry_url == undefined">
        <p>
        </p>
        <p>
        You can click <a href="https://apinsight.collegeboard.org/">here</a> to return to the AP Insight homepage.
        </p>
      </div>`,

    controller: ['$scope', 'config', '$stateParams', '$http', 'notify', '$window', '$state',
     function($scope, config, $stateParams, $http, notify, $window, $state) {
      $scope.data = {
      };
    }]
  });

  s.state('sso_school_not_present', {
    url: '/oauth_school_not_present',
    data: {
      title: 'AcademicMerit',
      public: true,
    },
    template: `
      <h3>AP Insight Product Unavailable For Your School</h3>
      <p>
          The school with which you are associated does not appear to have access to the AP Insight
          product. If you believe this is in error, please contact apinsight@collegeboard.org.
      </p>
      <p>
        Click <a href="http://www.collegeboard.org">here</a> to return to the College Board website.
      </p>`,

    controller: ['$scope', 'config', '$stateParams', '$http', 'notify', '$window', '$state',
     function($scope, config, $stateParams, $http, notify, $window, $state) {
      $scope.data = {
      };
    }]
  });

  s.state('sso_error', {
    url: '/oauth_error',
    data: {
      title: 'AcademicMerit',
      public: true,
    },
    template: `
      <h3>Login Failed</h3>
      <p>
          There has been an unexpected failure with your login. If this problem continues please contact
          apinsight@collegeboard.org.
      </p>
      <p>
        Click <a href="http://www.collegeboard.org">here</a> to return to the College Board website.
      </p>`,

    controller: ['$scope', 'config', '$stateParams', '$http', 'notify', '$window', '$state',
     function($scope, config, $stateParams, $http, notify, $window, $state) {
      $scope.data = {
      };
    }]
  });

  s.state('account', {
    parent: 'root',
    url: 'edit',
    data: {
      app_link: null
    },
    views: {
      '@': {
        templateUrl: require('common/User/my_account.html'),
        controller: ['$scope', 'user', 'notify', 'modalForm', 'change_password', 'check_login',
         function($scope, user, notify, modalForm, change_password, check_login) {
          check_login(user).then(logged_in => {
            if (logged_in) {
              window.location.reload();
            }
          });
          $scope.user = user;
          $scope.userHasCbLink = current_user.import_id && current_user.import_id == current_user.username;
          $scope.back = function(){
            window.history.back();
          };
          $scope.opts={no_email:!user.email || user.email.indexOf('@')===-1};
          if (user.email === user.username) {
            if ($scope.opts.no_email) {
              user.email = '';
            } else {
              user.username = '';
            }
          }
          $scope.before_save = function(user) {
            if ($scope.opts.no_email) {
              user.email = null;
            } else {
              user.username = null;
            }
            return user;
          };
          $scope.after_save = function(user) {
            window.current_user = user;
          };

          $scope.change_password = function() {
            return change_password(user);
          };
        }]
      }
    }
  });

  s.state('register', {
    url: '/register?code',
    data: {
      title: 'AcademicMerit',
      public: true,
    },
    templateUrl: require('AccountApp/register.html'),
    controller: ['$scope', 'config', '$stateParams', '$http', 'notify', '$window', '$state',
     function($scope, config, $stateParams, $http, notify, $window, $state) {
      $scope.data = {
        join_code: $stateParams.code
      };

      $scope.submit = function(data) {
        if ($scope.opts.no_email) {
          data.email = '';
        } else {
          data.username = '';
        }
        $http.post(config.api_url + '2/account/register', data)
          .success(function(response) {
            // Go to the portal because sometimes the class only has LC content
            $window.location.href='/';
          })
          .error(function(response) {
            notify.error(response && response.data || 'Network Error');
          });
      };
    }]
  });

  s.state('recover', {
    url: '/recover?email',
    data: {
      title: 'AcademicMerit',
      public: true,
    },
    templateUrl: require('AccountApp/recover.html'),
    controller: ['$scope', 'recover_password', 'throttle', '$state', 'notify', '$stateParams',
     function($scope, recover_password, throttle, $state, notify, $stateParams) {
      $scope.data = {name: $stateParams.email};
      $scope.recover = throttle(function(data) {
        recover_password(data.name)
          .then(function(sent) {
            if(sent === "true") {
              notify('An email has been sent to the address on file. Please allow up to ten minutes for receipt.');
            }
            else{
              notify.error('No account on file for that name.');
            }
          })
          .catch(function(response) {
            notify.error(response.data.message || response.data);
          });
      }, 5000, {trailing: false});
    }]
  });

  s.state('recover_code', {
    url: '/recover/:token/:expires',
    data: {
      title: 'AcademicMerit',
      public: true,
    },
    templateUrl: require('AccountApp/recover_code.html'),
    controller: ['$scope', 'set_password', '$stateParams', 'loginService', '$window', 'notify',
     function($scope, set_password, $stateParams, loginService, $window, notify) {
      var now = (new Date()).getTime() / 1000;
      $scope.token_expired = $stateParams.expires < now;

      $scope.data = {};

      $scope.set_password = function(data) {
        set_password({password: data.password, token: $stateParams.token})
          .then(function(result) {
            loginService.request_login(result.name, data.password).then(function() {
              $window.location.href = '/';
            });
          })
          .catch(function(result) {
            notify.error(result);
          });
      };
    }]
  });

}]);

m.factory('recover_password', ['$http', 'config', 'throttle', function($http, config, throttle) {
  return function(name) {
    return $http.post(config.api_url + '2/account/recover', {name: name}).then(function(response) {
      return response.data;
    });
  };
}]);

m.factory('check_login', ['loginService', '$cookieStore', '$q', function(loginService, $cookieStore, $q) {
  return function(user) {
    if (user.anonymous) {
      return loginService.login_user({username: $cookieStore.get('username')}).then(() => true);
    }
    return $q.when();
  };
}]);



/** WEBPACK FOOTER **
 ** ../AccountApp/AccountApp.js
 **/